import { Injectable } from "@angular/core";
import { ApiService } from "@edp-services/api.service";
import { EdpResponseBody } from "@edp-models/response.model";
import { catchError, map } from "rxjs/operators";
import { IUnavailability } from "@edp-models/unavailability.model";
import { BehaviorSubject, of } from "rxjs";
import { UnavailabilityType } from "@edp-enums/unavailability.enum";

const keySession = "unavailabilities";

@Injectable({
    providedIn: "root",
})
export class UnavailabilityService {
    public unavailability$ = new BehaviorSubject<IUnavailability | undefined>(null);

    constructor(private apiService: ApiService) {
        // reset unavailabilities on load
        this.removeSession();
    }

    public getUnavailability() {
        return this.apiService.callServicePost("unavailability.verifyByTarget", {}).pipe(
            map((response: EdpResponseBody) => {
                this.setSession(response.Result.Collection);
            }),
            catchError(error => {
                this.setSession([]);
                return of(undefined);
            })
        );
    }

    public setUnavailability(data: IUnavailability | undefined): void {
        this.unavailability$.next(data);
    }

    public checkRequested(): boolean {
        const storage = this.getSession();
        return storage !== undefined && Array.isArray(storage);
    }

    public removeSession(): void {
        sessionStorage.removeItem(keySession);
    }

    public setSession(data: IUnavailability[]): void {
        sessionStorage.setItem(keySession, JSON.stringify(data));
    }

    public getSession(): IUnavailability[]  {
        const data = sessionStorage.getItem(keySession);
        return data !== undefined ? JSON.parse(data) : undefined;
    }

    public findUnavailability(target: UnavailabilityType): void {
        const element = this.getSession().find(i => i.target === target);
        this.setUnavailability(element);
    }

}
